import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import ReportCustomFilterTypes from '../../../../common/redux/actions/types/ReportCustomFilterTypes';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
  getRequestParams,
} from '../redux/selectors/MessageProfileSelectors';

export function MessageProfileContainer(props) {
  let reportMode = '';

  if (props.requestParams) {
    reportMode = [
      props.requestParams.showSending ? 'sending' : 'receiving',
      props.requestParams.showMailBoxes ? 'with_mailboxes' : 'without_mailboxes',
    ].join('_');
  }

  return (
    <Report
      reportId={ReportDefinitions.MESSAGE_PROFILE.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
      customFilterType={ReportCustomFilterTypes.EDI_EXCHANGE_IPC}
      mode={reportMode}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
    requestParams: getRequestParams(state),
  };
}

MessageProfileContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  requestParams: PropTypes.objectOf(PropTypes.shape),
};

export default connect(mapStateToProps)(MessageProfileContainer);
